export enum SubscriptionType {
  Stripe = 1,
  Apple = 2,
  Reseller = 3,
}
